import { FormControlLabel, FormGroup, Switch, Grid } from '@mui/material';
import { useStoreState } from 'pullstate';
import { CurrentScan } from '../../../stores/CurrentScan';
import ScanButton from '../ScanButton/ScanButton';
import './ScanOptions.css';
import ScanStats from '../ScanStats/ScanStats';
import ScanModelSelect from '../ScanModelSelect/ScanModelSelect';

const ScanOptions = () => {
    const { aiCheck, plagiarismCheck, scanDisabled, wordCount, credits, results } =
        useStoreState(CurrentScan);

    const handleSwitch = (switchName) => {
        // console.log(switchName);
        CurrentScan.update((s) => {
            switch (switchName) {
                case 'aiCheck':
                    s.aiCheck = !s.aiCheck;
                    break;
                case 'plagiarismCheck':
                    s.plagiarismCheck = !s.plagiarismCheck;
                    break;
                default:
                    break;
            }
        });
    };

    return (
        <Grid
            container
            className='ScanOptions'
            sx={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'wrap',
                justifyContent: 'space-between',
                alignItems: 'flex-start',
                marginTop: '1rem',
                marginBottom: '1rem',
            }}
        >
            <Grid
                item
                xs={12}
                md={6}
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                    gap: '1rem',
                }}
            >
                {!results && (
                    <FormGroup sx={{ display: 'flex', flexDirection: 'row' }}>
                        <FormControlLabel
                            control={
                                <Switch
                                    disabled={scanDisabled}
                                    checked={aiCheck || false}
                                    onChange={() => handleSwitch('aiCheck')}
                                    color={aiCheck ? 'success' : 'primary'}
                                />
                            }
                            label='AI Content'
                        />
                        <FormControlLabel
                            control={
                                <Switch
                                    disabled={scanDisabled}
                                    checked={plagiarismCheck || false}
                                    onChange={() => handleSwitch('plagiarismCheck')}
                                    color={plagiarismCheck ? 'success' : 'primary'}
                                />
                            }
                            label='Plagiarized Content'
                        />
                    </FormGroup>
                )}
            </Grid>
            <Grid
                item
                xs={12}
                md={6}
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'flex-end',
                    gap: '1rem',
                }}
            >
                <ScanStats wordCount={wordCount} credits={credits} />
                <ScanModelSelect />
                <ScanButton />
            </Grid>
        </Grid>
    );
};

export default ScanOptions;
